<template>
  <div class="main-wrapper">
    <div class="container">
      <div class="invoice-wrapper index-three">
        <div class="inv-content">
          <div class="invoice-header">
            <div class="inv-header-right">
              <div class="invoice-title">TAX INVOICE</div>
            </div>
          </div>
          <div class="invoiceeight-header">
            <div class="invoice-header-top">
              <div class="inv-header-left">
                <a href="javascript:;">
                  <img src="@/assets/img/logo2.png" alt="Logo" />
                </a>
              </div>
              <div class="inv-header-right">
                <div class="inv-details">
                  <div class="inv-date">Invoice No: <span>00001</span></div>
                  <div class="inv-date mb-0">Date: <span>5/12/2022</span></div>
                </div>
              </div>
            </div>
            <div class="invoice-header-bottom">
              <div class="company-details">
                <span class="company-name invoice-title">Dreamguys</span>
                <div class="company-content">
                  <div class="company-content-left">
                    <div class="company-info">
                      <div class="gst-details">GST IN: <span>22AABCU9603R1ZX</span></div>
                      <div class="gst-details me-0">
                        Mobile: <span>+ 91 98765 43210</span>
                      </div>
                    </div>
                    <div class="gst-details company-address mb-0 me-0">
                      Address:
                      <span>5 Hodges Mews, High Wycombe HP12 3JL, United Kingdom</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="invoice-address">
                <div class="invoice-to">
                  <span>Invoice To:</span>
                  <div class="inv-to-address">
                    Walter Roberson<br />
                    299 Star Trek Drive, Panama City, <br />
                    Florida, 32405, USA.<br />
                    walter@example.com <br />
                    +45 5421 4523
                  </div>
                </div>
                <div class="invoice-to">
                  <span>Pay To:</span>
                  <div class="inv-to-address">
                    Lowell H. Dominguez<br />
                    84 Spilman Street, London<br />
                    United Kingdom<br />
                    lowell@example.com<br />
                    +45 5421 2154
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="invoice-table">
            <div class="table-responsive">
              <table>
                <thead>
                  <tr>
                    <th class="table_width_1">#</th>
                    <th class="table_width_2">Item</th>
                    <th class="text-center">Rate/Item</th>
                    <th class="text-center">Qty</th>
                    <th class="text-center">Tax Value</th>
                    <th class="text-center">Tax Amount</th>
                    <th class="text-end">Amount</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>1</td>
                    <td class="table-description">
                      Samsung Galaxy M32 Prime Edition...<span
                        >( Light Blue, 4GB RAM, 64GB )</span
                      >
                    </td>
                    <td class="text-center">15,677.10</td>
                    <td class="text-center">1</td>
                    <td class="text-center">15,677.15</td>
                    <td class="text-center">2,821.88(18%)</td>
                    <td class="text-end">18,499.00</td>
                  </tr>
                  <tr>
                    <td>2</td>
                    <td class="table-description">
                      OPPO A74 5G...<span>( Fluid Black, 6GB RAM, 128GB Storage )</span>
                    </td>
                    <td class="text-center">2,541.53</td>
                    <td class="text-center">1</td>
                    <td class="text-center">2,541.53</td>
                    <td class="text-center">457.48(18%)</td>
                    <td class="text-end">2,999.00</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="invoice-table-footer">
            <div class="table-footer-left notes">
              <span>Total Items / Qty : 2 / 2.00</span>
            </div>
            <div class="text-end table-footer-right">
              <table>
                <tbody>
                  <tr>
                    <td>Total</td>
                    <td>₹21,498.00</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="invoice-table-footer">
            <div class="table-footer-left notes">
              <span></span>
            </div>
            <div class="text-end table-footer-right">
              <table>
                <tbody>
                  <tr>
                    <td>IGST 18.0%</td>
                    <td>₹21,498.00</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="invoice-table-footer">
            <div class="table-footer-left notes">
              <span></span>
            </div>
            <div class="text-end table-footer-right amount-payable">
              <table>
                <tbody>
                  <tr>
                    <td class="invoice-title">Amount Payable</td>
                    <td class="invoice-title">₹21,498.00</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="total-amountdetails">
            <p>
              Total amount ( in words):
              <span>$ Twenty-One Thousand, Four Hundred and Ninety-Eight Only.</span>
            </p>
          </div>
          <div class="bank-details">
            <div class="account-info">
              <span class="bank-title">Bank Details</span>
              <div class="account-details-infotop">
                <div class="account-details">Bank : <span>YES Bank</span></div>
                <div class="account-details">IFSC : <span>YESBBIN4567</span></div>
              </div>
              <div class="account-details-infotop">
                <div class="account-details">Account # :<span> 6677889944551 </span></div>
                <div class="account-details">BRANCH : <span>Newyork</span></div>
              </div>
            </div>
            <div class="company-sign">
              <span>For Dreamguys</span>
              <img src="@/assets/img/signature.png" alt="" />
            </div>
          </div>
          <div class="invoice-footer">
            <div class="thanks-msg">
              <span>Notes:</span>
              Thanks for your Business
            </div>
            <div class="terms-condition">
              <span>Terms and Conditions:</span>
              <ol>
                <li>Goods Once sold cannot be taken back or exchanged</li>
                <li>
                  We are not the manufactures, company will stand for warrenty as per
                  their terms and conditions.
                </li>
              </ol>
            </div>
          </div>
        </div>
      </div>
      <div class="file-link">
        <button class="download_btn download-link">
          <i class="feather-download-cloud me-1"></i> <span>Download</span>
        </button>
        <a href="javascript:window.print()" class="print-link">
          <i class="feather-printer"></i> <span class="">Print</span>
        </a>
      </div>
    </div>
  </div>
</template>
